import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';

import DesignerBoardMobileComponent from 'webapp/components/designer/board/mobile';
import DesignerBoardWallComponent from 'webapp/components/designer/board/wall';
import DesignerLoopBoxComponent from 'webapp/components/designer/loop-box';
import type DesignerBoardController from 'webapp/controllers/designer/board';

interface Args {
	controller: DesignerBoardController;
}

const DesignerBoardRouteTemplate: TOC<Args> = <template>
	{{#if @controller.boardState}}

		{{#if @controller.board.isWallPrimary}}

			<DesignerBoardWallComponent
				@board={{@controller.board}}
				@boardState={{@controller.boardState}}
				@onSave={{@controller.saveBoard}}
				@onDelete={{@controller.deleteBoard}}
				@onCopy={{@controller.copyBoard}}
				@onDatawallGridChange={{@controller.datawallGridChange}}
				@onLoopChange={{@controller.openLoop}}
				@designerController={{@controller.designerController}}
			/>

			{{#if @controller.showLoopBox}}
				<DesignerLoopBoxComponent
					@model={{@controller.loop}}
					@activeBoard={{@controller.board}}
					@onBoardChange={{@controller.openBoard}}
					@onLoopChange={{@controller.openLoop}}
				/>
			{{/if}}

		{{else if @controller.board}}

			<DesignerBoardMobileComponent
				@board={{@controller.board}}
				@boardState={{@controller.boardState}}
				@onSave={{@controller.saveBoard}}
				@onDelete={{@controller.deleteBoard}}
				@onCopy={{@controller.copyBoard}}
				@onLoopChange={{@controller.openLoop}}
				@onInit={{fn @controller.datawallGridChange null}}
				@designerController={{@controller.designerController}}
			/>

		{{/if}}

	{{/if}}
</template>;

export default DesignerBoardRouteTemplate;
